import axios from "axios"
import { fetchAccessToken } from "../utils/token"
import { BRIDGE_URL } from "../utils/constants"
import { getSendEmail } from "./getSendEmail";

// Update appointment to confirmed
export const patchConfirmAppointment = async (appointmentId, clientId, customerEmail = null) => {

    try {

        const token = localStorage.getItem("oss-token")
        if(!token) fetchAccessToken()

        const formBody = {
            appointmentId,
            clientId
        }

        const headers = {
            Authorization: `Bearer ${token}`
        }

        const res = await axios.patch(`${BRIDGE_URL("services/apexrest/appointment/confirm/")}`, formBody, { headers })

        console.log(res.data);
        console.log('confirm');

        // if(res.data.status == 'Confirmed'){
        //     const emailResponse = await getSendEmail(customerEmail, "confirm", appointmentId);
        //     console.log(emailResponse);
        // }

        return res.data

    } catch (err) {
        console.log(err)
    }

}